import { Component } from 'angular-ts-decorators';

import { isString } from 'lodash';

import { Domain } from '@shared/app/scripts/services/domain';
import { CookieStreams } from '@shared/app/scripts/services/cookie-streams';

/**
 * Route componet, shows the login-widget & rediects back on success
 *
 * @example
 * <login></login>
 */
@Component({
  selector: 'login',
  template: require('./login.html').default,
})
export class LoginComponent {
  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $window: ng.IWindowService,
    private cookieStreams: CookieStreams,
    private domain: Domain,
  ) {
    'ngInject';
  }

  onSuccess() {
    let target = this.$routeParams.redirect;

    // Not valid; fall back to default
    if (!isString(target) || target.length < 1) {
      target = this.domain.link('www');
    }

    this.$window.location.href = target;
  }

  ngOnInit() {
    // redirect on sid changes
    this.cookieStreams.getChange$('sid').subscribe(() => this.onSuccess());
  }
}
